<ng-container
    *ngTemplateOutlet="isAuthRoute() ? authRoute : defaultLayout"
></ng-container>

<ng-template #authRoute>
    <app-auth></app-auth>
</ng-template>

<ng-template #defaultLayout>
    <div class="admin-layout">
        <div class="admin-header">
            <div class="admin-content-shell">
                <app-header-v2
                  [layout]="'admin'"
                  [navigationButtons]="navigationButtons()"
                  [user]="admin()"
                ></app-header-v2>
            </div>
        </div>
        <main class="admin-main">
            <div class="admin-content-shell">
                <router-outlet></router-outlet>
            </div>
        </main>
    </div>
</ng-template>
